import { useEffect } from "react";

const Index = () => {
  useEffect(() => {
    window.location.replace("/projects");
  }, []);

  return <> Redirecting.... </>;
};

export default Index;
